import React, { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import PropTypes from 'prop-types';
import cns from 'classnames';

const CopyLink = (props) => {
    const { text = 'Copy Link', successText = 'Link Copied', onCopy, copyText } = props;
    const [copySuccess, setCopySuccess] = useState(false);

    const onCopyHandler = () => {
        if (onCopy) {
            onCopy();
        }
        setTimeout(() => setCopySuccess(false), 5000);
        return setCopySuccess(true);
    };

    if (copySuccess) {
        return (
            <span className={cns('verbLink copy-link success')}>
                <i className={'fad fa-check-circle'}></i> {successText}
            </span>
        );
    }

    return (
        <CopyToClipboard text={copyText} onCopy={onCopyHandler}>
            <span className={'verbLink copy-link'}>
                <i className={'fal fa-link'}></i> {text}
            </span>
        </CopyToClipboard>
    );
};

CopyLink.propTypes = {
    text: PropTypes.string,
    successText: PropTypes.string,
    copyText: PropTypes.string,
    onCopy: PropTypes.func
};

export default CopyLink;
